var _path, _polygon, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SurinameCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b71c1c",
    d: "M42.838,30.667C43.577,28.579,44,26.341,44,24c0-2.341-0.423-4.579-1.162-6.667H5.162 C4.423,19.421,4,21.659,4,24c0,2.341,0.423,4.579,1.162,6.667H42.838z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffca28",
    points: "24,18 25.517,22.478 30.244,22.537 26.454,25.363 27.859,29.877 24,27.146 20.141,29.877 21.546,25.363 17.756,22.537 22.483,22.478"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M41.408,14.213C37.984,8.124,31.484,4,24,4S10.016,8.124,6.592,14.213H41.408z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M5.21,17.213c-0.015,0.041-0.034,0.08-0.048,0.121h37.675c-0.014-0.041-0.033-0.08-0.048-0.121 H5.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M42.832,30.681c0.002-0.005,0.004-0.009,0.006-0.014H5.162c0.002,0.005,0.004,0.009,0.006,0.014 H42.832z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M6.529,33.681C9.937,39.829,16.471,44,23.999,44h0.002c7.528,0,14.062-4.171,17.47-10.319H6.529z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M42.793,17.213c-0.376-1.042-0.825-2.047-1.362-3H6.568c-0.536,0.953-0.985,1.958-1.362,3H42.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M6.504,33.681h34.993c0.529-0.953,0.967-1.96,1.336-3H5.168 C5.537,31.721,5.975,32.728,6.504,33.681z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SurinameCircular);
export default __webpack_public_path__ + "static/media/icons8-suriname-circular.b57bc181c346629be892f1c3cc6cb2bf.svg";
export { ForwardRef as ReactComponent };